import './Link.css';

function Button({
    text,
    href,
    transparent
}) {
    return(
        <a
            href={href}
            className={`link ${transparent ? "transparent" : ""}`}
        >
            {text}
        </a>
    );
}

export default Button;